/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateNotificacaoFormDto } from '../models/create-notificacao-form-dto';
import { NotificacaoCriteriaDto } from '../models/notificacao-criteria-dto';
import { NotificacaoDto } from '../models/notificacao-dto';
import { NotificacaoPageDto } from '../models/notificacao-page-dto';


/**
 * Notificações
 */
@Injectable({
  providedIn: 'root',
})
export class NotificacoesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getNotificacoes
   */
  static readonly GetNotificacoesPath = '/notificacoes';

  /**
   * Pesquisar notificações.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificacoes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificacoes$Response(params?: {
    criteria?: NotificacaoCriteriaDto;
  }): Observable<StrictHttpResponse<NotificacaoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, NotificacoesService.GetNotificacoesPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NotificacaoPageDto>;
      })
    );
  }

  /**
   * Pesquisar notificações.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getNotificacoes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificacoes(params?: {
    criteria?: NotificacaoCriteriaDto;
  }): Observable<NotificacaoPageDto> {

    return this.getNotificacoes$Response(params).pipe(
      map((r: StrictHttpResponse<NotificacaoPageDto>) => r.body as NotificacaoPageDto)
    );
  }

  /**
   * Path part for operation createNotificacao
   */
  static readonly CreateNotificacaoPath = '/notificacoes';

  /**
   * Criar notificação.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createNotificacao()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNotificacao$Response(params?: {

    /**
     * apiRequest
     */
    body?: CreateNotificacaoFormDto
  }): Observable<StrictHttpResponse<NotificacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, NotificacoesService.CreateNotificacaoPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NotificacaoDto>;
      })
    );
  }

  /**
   * Criar notificação.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createNotificacao$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNotificacao(params?: {

    /**
     * apiRequest
     */
    body?: CreateNotificacaoFormDto
  }): Observable<NotificacaoDto> {

    return this.createNotificacao$Response(params).pipe(
      map((r: StrictHttpResponse<NotificacaoDto>) => r.body as NotificacaoDto)
    );
  }

  /**
   * Path part for operation getNotificacao
   */
  static readonly GetNotificacaoPath = '/notificacoes/{id}';

  /**
   * Obter notificação.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificacao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<NotificacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, NotificacoesService.GetNotificacaoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NotificacaoDto>;
      })
    );
  }

  /**
   * Obter notificação.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getNotificacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificacao(params: {
    id: number;
  }): Observable<NotificacaoDto> {

    return this.getNotificacao$Response(params).pipe(
      map((r: StrictHttpResponse<NotificacaoDto>) => r.body as NotificacaoDto)
    );
  }

  /**
   * Path part for operation ativarNotificacao
   */
  static readonly AtivarNotificacaoPath = '/notificacoes/{id}/ativar';

  /**
   * Ativar Notificação de sistema.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarNotificacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarNotificacao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<NotificacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, NotificacoesService.AtivarNotificacaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NotificacaoDto>;
      })
    );
  }

  /**
   * Ativar Notificação de sistema.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarNotificacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarNotificacao(params: {
    id: number;
  }): Observable<NotificacaoDto> {

    return this.ativarNotificacao$Response(params).pipe(
      map((r: StrictHttpResponse<NotificacaoDto>) => r.body as NotificacaoDto)
    );
  }

  /**
   * Path part for operation arquivarNotificacao
   */
  static readonly ArquivarNotificacaoPath = '/notificacoes/{id}/arquivar';

  /**
   * Arquivar Notificação de sistema.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `arquivarNotificacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  arquivarNotificacao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<NotificacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, NotificacoesService.ArquivarNotificacaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NotificacaoDto>;
      })
    );
  }

  /**
   * Arquivar Notificação de sistema.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `arquivarNotificacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  arquivarNotificacao(params: {
    id: number;
  }): Observable<NotificacaoDto> {

    return this.arquivarNotificacao$Response(params).pipe(
      map((r: StrictHttpResponse<NotificacaoDto>) => r.body as NotificacaoDto)
    );
  }

  /**
   * Path part for operation desativarNotificacao
   */
  static readonly DesativarNotificacaoPath = '/notificacoes/{id}/desativar';

  /**
   * Desativar Notificação de sistema.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarNotificacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarNotificacao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<NotificacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, NotificacoesService.DesativarNotificacaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NotificacaoDto>;
      })
    );
  }

  /**
   * Desativar Notificação de sistema.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarNotificacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarNotificacao(params: {
    id: number;
  }): Observable<NotificacaoDto> {

    return this.desativarNotificacao$Response(params).pipe(
      map((r: StrictHttpResponse<NotificacaoDto>) => r.body as NotificacaoDto)
    );
  }

  /**
   * Path part for operation lerNotificacao
   */
  static readonly LerNotificacaoPath = '/notificacoes/{id}/ler';

  /**
   * Ler Notificação de sistema.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lerNotificacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  lerNotificacao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<NotificacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, NotificacoesService.LerNotificacaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NotificacaoDto>;
      })
    );
  }

  /**
   * Ler Notificação de sistema.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `lerNotificacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lerNotificacao(params: {
    id: number;
  }): Observable<NotificacaoDto> {

    return this.lerNotificacao$Response(params).pipe(
      map((r: StrictHttpResponse<NotificacaoDto>) => r.body as NotificacaoDto)
    );
  }

  /**
   * Path part for operation sendEmailNotificacoes
   */
  static readonly SendEmailNotificacoesPath = '/notificacoes/email/task/run';

  /**
   * Enviar emails notificacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendEmailNotificacoes()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendEmailNotificacoes$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, NotificacoesService.SendEmailNotificacoesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Enviar emails notificacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendEmailNotificacoes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendEmailNotificacoes(params?: {
  }): Observable<void> {

    return this.sendEmailNotificacoes$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
